import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_INVOICES](state, data) {
    console.log('mutation ', data)
    state.allInvoices = data
  },
  [types.SAVE_INVOICE](state, data) {
    console.log('mutation ', data)
    state.invoice = data
  },
}
